export function setStateMenu(stateMenu) {
    const statusMenu = {
        stateMenu: stateMenu,
    };
    localStorage.setItem('menuMainState', JSON.stringify(statusMenu));
}
export function getStateMenu() {
    const menuMainState = localStorage.getItem('menuMainState');
    if (menuMainState !== null) {
        const statusMenuObject = JSON.parse(menuMainState);
        if(statusMenuObject.stateMenu) {
            return statusMenuObject.stateMenu;
        }
    }
    return false;
}
